
import { AppInitializer } from "@components/Common/AppInitializer";
import ThemeProvider from "@components/providers/ThemeProvider";
import { ToastProvider } from "@context/ToastContext";
import router from "@router";
import { store } from "@store/index";
import { Provider } from "react-redux";
import { RouterProvider } from "react-router-dom";
function App() {
  return (
    <ToastProvider>
      <Provider store={store}>
        <ThemeProvider>
          <AppInitializer>
            <RouterProvider router={router} />
          </AppInitializer>
        </ThemeProvider>
      </Provider>
    </ToastProvider>
  );
}

export default App;